import React from "react";
import "./CategoryLoader.scss";

const Basketball = () => (
  <svg viewBox="0 0 866 866" xmlns="http://www.w3.org/2000/svg">
    <path
      className="bb-0"
      d="M142.327 112.062C214.1 47.017 307.79 5.714 411 .55V410.5H280.346c-8.144-184.333-121.358-284.64-138.02-298.438z"
      fill="currentColor"
    />
    <path
      className="bb-1"
      d="M111.104 143.388C46.716 214.908 5.822 307.995.574 410.5h235.893c-7.19-145.817-109.942-251.965-125.363-267.112z"
      fill="currentColor"
    />
    <path
      className="bb-2"
      d="M110.902 722.388C46.422 650.666 5.552 557.292.524 454.5h235.788c-8.297 149.66-114.564 257.273-125.41 267.888z"
      fill="currentColor"
    />
    <path
      className="bb-3"
      d="M141.633 753.308C213.497 818.716 307.458 860.268 411 865.45V454.5H280.354c-8.297 189.4-127.334 289.638-138.72 298.808z"
      fill="currentColor"
    />
    <path
      className="bb-4"
      d="M723.222 754.346C651.507 819.156 557.992 860.296 455 865.45V454h129.39c7.743 190.638 127.705 291.398 138.832 300.346z"
      fill="currentColor"
    />
    <path
      className="bb-5"
      d="M754.06 723.538C819.244 651.55 860.555 557.54 865.5 454H628.416c7.704 151.184 115.666 259.807 125.644 269.538z"
      fill="currentColor"
    />
    <path
      className="bb-6"
      d="M754.82 143.302C819.145 214.716 860.042 307.652 865.4 410H628.418c8.043-149.258 115.93-256.613 126.4-266.698z"
      fill="currentColor"
    />
    <path
      className="bb-7"
      d="M723.687 112.075C651.91 47.022 558.217 5.715 455 .55V410h129.53c8.944-188.743 128.016-288.947 139.157-297.925z"
      fill="currentColor"
    />
  </svg>
);

const Soccer = () => (
  <svg viewBox="0 0 866 866" xmlns="http://www.w3.org/2000/svg">
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 164.83 151.5"
    >
      <path
        className="bb-0"
        d="M117.24,69.24A8,8,0,0,0,115.67,67c-4.88-4-9.8-7.89-14.86-11.62A4.93,4.93,0,0,0,96.93,55c-5.76,1.89-11.4,4.17-17.18,6a4.36,4.36,0,0,0-3.42,4.12c-1,6.89-2.1,13.76-3,20.66a4,4,0,0,0,1,3.07c5.12,4.36,10.39,8.61,15.68,12.76a3.62,3.62,0,0,0,2.92.75c6.29-2.66,12.52-5.47,18.71-8.36a3.49,3.49,0,0,0,1.68-2.19c1.34-7.25,2.54-14.55,3.9-22.58Z"
        fill="currentColor"
      />
      <path
        className="bb-1"
        d="M97.55,38.68A43.76,43.76,0,0,1,98,33.44c.41-2.36-.5-3.57-2.57-4.64C91.1,26.59,87,24,82.66,21.82a6.18,6.18,0,0,0-4-.71C73.45,22.55,68.32,24.25,63.22,26c-3.63,1.21-6.08,3.35-5.76,7.69a26.67,26.67,0,0,1-.6,4.92c-1.08,8.06-1.08,8.08,5.86,11.92,3.95,2.19,7.82,5.75,11.94,6.08s8.76-2.41,13.12-3.93c9.33-3.29,9.33-3.3,9.78-14Z"
        fill="currentColor"
      />
      <path
        className="bb-2"
        d="M66.11,126.56c5.91-.91,11.37-1.7,16.81-2.71a3.3,3.3,0,0,0,1.87-2.17c1-4.06,1.73-8.19,2.84-12.24.54-2-.11-3-1.55-4.15-5-4-9.9-8.12-15-12a6.19,6.19,0,0,0-4.15-1.1c-5.35.66-10.7,1.54-16,2.54A4,4,0,0,0,48.34,97a109.13,109.13,0,0,0-3,12.19,4.47,4.47,0,0,0,1.34,3.6c5.54,4.36,11.23,8.53,16.91,12.69a10.84,10.84,0,0,0,2.57,1.11Z"
        fill="currentColor"
      />
      <path
        className="bb-3"
        d="M127.42,104.12c4.1-2.1,8-3.93,11.72-6a6,6,0,0,0,2.27-3,58.22,58.22,0,0,0,3.18-29.92c-.26-1.7-8-7.28-9.71-6.85A5,5,0,0,0,133,59.65c-2.81,2.49-5.71,4.88-8.33,7.56a9.46,9.46,0,0,0-2.47,4.4c-1.29,6.49-2.38,13-3.35,19.55a5.73,5.73,0,0,0,.83,3.91c2.31,3.08,5,5.88,7.7,9Z"
        fill="currentColor"
      />
      <path
        className="bb-4"
        d="M52.58,29.89c-2.15-.36-3.78-.54-5.39-.9-2.83-.64-4.92.1-7,2.32A64.1,64.1,0,0,0,26.09,54.64c-2.64,7.92-2.62,7.84,5.15,10.87,1.76.69,2.73.45,3.93-1C39.79,59,44.54,53.65,49.22,48.2a4.2,4.2,0,0,0,1.13-2c.8-5.32,1.49-10.68,2.24-16.34Z"
        fill="currentColor"
      />
      <path
        className="bb-5"
        fill="currentColor"
        d="M23,68.13c0,2.51,0,4.7,0,6.87a60.49,60.49,0,0,0,9.75,32.15c1.37,2.13,6.4,3,7,1.2,1.55-5,2.68-10.2,3.82-15.34.13-.58-.58-1.38-.94-2.06-2.51-4.77-5.47-9.38-7.45-14.37C32.94,71,28.22,69.84,23,68.13Z"
      />
      <path
        className="bb-6"
        fill="currentColor"
        d="M83.91,12.86c-.32.36-.66.71-1,1.07.9,1.13,1.57,2.62,2.73,3.33,4.71,2.84,9.56,5.48,14.39,8.1a9.29,9.29,0,0,0,3.13.83c5.45.69,10.89,1.38,16.35,1.94a10.41,10.41,0,0,0,3.07-.71c-11.48-9.9-24.26-14.61-38.71-14.56Z"
      />
      <path
        className="bb-7"
        fill="currentColor"
        d="M66.28,132.51c13.36,3.78,25.62,3.5,38-.9C91.68,129.59,79.36,128,66.28,132.51Z"
      />
      <path
        className="bb-8"
        fill="currentColor"
        d="M127.2,30.66l-1.27.37a18.58,18.58,0,0,0,1,3.08c3,5.52,6.21,10.89,8.89,16.54,1.34,2.83,3.41,3.82,6.49,4.9a60.38,60.38,0,0,0-15.12-24.9Z"
      />
      <path
        className="bb-9"
        fill="currentColor"
        d="M117.35,125c5.58-2.32,16.9-13.84,18.1-19.2-2.41,1.46-5.18,2.36-6.78,4.23-4.21,5-7.89,10.37-11.32,15Z"
      />
    </svg>
  </svg>
);

const IceHockey = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 164.83 151.5"
  >
    <path
      className="bb-0"
      fill="currentColor"
      d="M132,92.57a10.53,10.53,0,0,1-.22,1.11l-.06.26c-.09.3-.22.62-.35.95l-.11.24c-.18.4-.35.76-.55,1.12l-.13.24a18.12,18.12,0,0,1-1,1.53l-.18.25a22.35,22.35,0,0,1-1.53,1.78l-.31.32c-.29.29-.57.56-.86.82l-.39.36c-.43.38-.86.76-1.33,1.12l-.11.09c-.64.49-1.24.93-1.86,1.36l-.44.3a47,47,0,0,1-5.68,3.23c-1.38.66-2.64,1.2-3.94,1.72l-.31.12c-.76.29-1.51.57-2.28.83l-.62.21c-1.79.61-3.66,1.15-5.58,1.63l-.7.17q-1.18.28-2.38.54l-.65.14q-1.81.36-3.67.65l-.64.1c-1.26.19-2.55.36-3.86.5l-.22,0c-1.47.15-2.8.26-4.14.35l-.28,0c-1.36.08-2.74.13-4.12.15l-1.62,0c-1.4,0-2.78,0-4.15-.09l-.58,0c-1.35-.06-2.68-.15-4-.27l-.7-.07c-1.32-.13-2.61-.27-3.89-.46l-.5-.07c-1.21-.18-2.41-.37-3.59-.59l-.38-.07c-1.22-.24-2.42-.5-3.6-.78l-.61-.15q-1.67-.42-3.29-.89l-.65-.2c-1.07-.33-2.13-.67-3.16-1l-.32-.12c-.94-.34-1.87-.72-2.78-1.1l-.57-.23q-1.16-.51-2.27-1l-.53-.27c-.59-.3-1.16-.6-1.72-.91l-.6-.33c-.68-.39-1.35-.79-2-1.2l-.18-.12c-.57-.37-1.12-.76-1.65-1.15l-.25-.17-1-.82-.62-.52-.64-.56-.54-.5-.58-.58L36,100c-.18-.19-.35-.39-.52-.58L35,98.9l-.8-1.05c-.12-.17-.65-1-.65-1l-.28-.52L33,95.83,32.68,95l-.08-.19c0-.12-.11-.33-.18-.54l-.12-.34-.09-.36-.09-.47,0-.32L32,92.24V92L32,84.73l.93.93.73.68.77.67.79.66.83.65.72.54c.62.46,1.28.91,2,1.36l.19.13c.73.47,1.5.93,2.29,1.38l.68.38c.63.35,1.28.69,2,1l.57.29c.81.39,1.66.78,2.53,1.16l.58.24c1,.42,2.05.84,3.13,1.23l.28.11c1.1.39,2.25.77,3.43,1.13l.62.19c1.17.34,2.35.67,3.56,1l.65.15c1.25.3,2.52.58,3.82.83,1.48.28,2.81.5,4.15.69l.6.09c1.32.18,2.67.34,4,.47l.82.08c1.36.12,2.74.22,4.13.28l.56,0c1.58.07,3,.1,4.45.1l1.78,0q2.13,0,4.22-.15l.25,0c1.51-.09,2.85-.21,4.17-.34l.55-.05c1.33-.14,2.66-.32,4-.51l.78-.13c1.29-.2,2.57-.43,3.82-.68l.71-.15c.83-.18,1.65-.36,2.45-.56l.84-.2c1-.26,2-.52,3-.8l.2-.07c.88-.26,1.79-.55,2.69-.85l.77-.26c.78-.27,1.52-.54,2.26-.83l.53-.2q2.11-.84,4.06-1.77l.24-.11q2-1,3.84-2c1-.57,1.77-1.08,2.55-1.6l.57-.39c.79-.54,1.55-1.09,2.26-1.66l.18-.15c.51-.41,1-.84,1.51-1.28l.4-.37c.5-.46.86-.81,1.2-1.16l.51-.53.05,7.45A7.91,7.91,0,0,1,132,92.57Z"
    />
    <path
      className="bb-1"
      fill="currentColor"
      d="M116.62,57.4c-9.17-5.2-21.45-8.06-34.74-8.06-28.81.05-47.2,13.78-47.2,23.2,0,3.81,3.27,9.73,12.45,14.92s21.45,8.05,34.57,8.05h.16c28.82-.06,47.2-13.76,47.2-23.17C129.07,68.54,125.8,62.6,116.62,57.4Zm-34.76,35h-.14c-11.37,0-22-2.48-30-7S41,75.84,41,72.54c0-8.17,15.94-20.06,40.91-20.11,11.52,0,22.16,2.48,30.1,7s10.79,9.65,10.79,13C122.77,80.52,106.83,92.4,81.86,92.45Z"
    />
    <path
      className="bb-2"
      fill="currentColor"
      d="M89.73,69a16.2,16.2,0,0,0-7.86-1.82c-6.52,0-10.67,3.11-10.67,5.25,0,.86.74,2.2,2.81,3.37a16.16,16.16,0,0,0,7.82,1.82h0c6.51,0,10.67-3.11,10.67-5.24C92.54,71.56,91.8,70.21,89.73,69Z"
    />
    <path
      className="bb-3"
      fill="currentColor"
      d="M106.53,61.77c-6.5-3.69-15.22-5.72-24.65-5.72-20.45,0-33.5,9.78-33.5,16.47,0,2.7,2.32,6.9,8.83,10.59s15.23,5.72,24.54,5.72h.12c20.45,0,33.5-9.77,33.5-16.45C115.36,69.67,113,65.46,106.53,61.77ZM81.86,84.29h-.08c-6.74,0-13-1.47-17.76-4.14s-6.39-5.71-6.39-7.66c0-4.84,9.45-11.89,24.24-11.92C88.7,60.58,95,62,99.71,64.72s6.39,5.72,6.39,7.68C106.1,77.23,96.66,84.27,81.86,84.29Z"
    />
  </svg>
);

const Volleyball = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 164.83 151.5"
  >
    <path
      className="bb-0"
      fill="currentColor"
      d="M83.16,71.77A55.5,55.5,0,0,1,68.32,47.86c9.62-2.2,43.69-8.24,72.54,11a59.88,59.88,0,0,1,2.2,15.66,52.33,52.33,0,0,1-1.92,14.84C118.33,66.55,89.75,70.39,83.16,71.77Z"
    />
    <path
      className="bb-1"
      fill="currentColor"
      d="M60.62,99.25c-6-8-27.2-38.75-14.56-72V26.7a64.7,64.7,0,0,1,15.39-8.52,60.44,60.44,0,0,0,.82,28.3v.27a.27.27,0,0,0,.27.27,69.36,69.36,0,0,0,17,28.85A71.23,71.23,0,0,1,60.62,99.25Z"
    />
    <path
      className="bb-2"
      fill="currentColor"
      d="M138.12,50.88C108.44,34.4,76.29,40.44,66.94,42.64a54.26,54.26,0,0,1,.82-26.38,66.54,66.54,0,0,1,14.84-1.92A60.78,60.78,0,0,1,138.12,50.88Z"
    />
    <path
      className="bb-3"
      fill="currentColor"
      d="M38.37,33.85c-7.69,32.43,11.27,60.45,17.86,68.7a63.84,63.84,0,0,1-21.43,9.07A60.4,60.4,0,0,1,22.43,75.06,57.71,57.71,0,0,1,38.37,33.85Z"
    />
    <path
      className="bb-4"
      fill="currentColor"
      d="M38.64,116A71.42,71.42,0,0,0,85.08,77a62.11,62.11,0,0,1,31.6,2.75C113.38,88,98,123.15,63.1,131.67A56.06,56.06,0,0,1,38.64,116Z"
    />
    <path
      className="bb-5"
      fill="currentColor"
      d="M82.61,135.24a56.84,56.84,0,0,1-9.62-.82c31.33-12.09,45.34-43.69,48.64-52.21a59.91,59.91,0,0,1,17.86,13.46A60.63,60.63,0,0,1,82.61,135.24Z"
    />
  </svg>
);

const CategoryLoader = ({ category, isLoading, children }) => {
  return isLoading ? (
    <div className="main-fader">
      <div className="wrapper-loader">
        {category === "basketball" && <Basketball />}
        {category === "soccer" && <Soccer />}
        {category === "ice-hockey" && <IceHockey />}
        {category === "volleyball" && <Volleyball />}
      </div>
    </div>
  ) : (
    children
  );
};

export default CategoryLoader;
